import { JobsState, JobsFilters, JobsContextItem, CurrentJob, AvailableJobsResponseData } from '@/models/JobsState';
import { MutationTree } from 'vuex';

export const JobsMutations = {
	UPDATE_AVAILABLE_JOBS: 'UPDATE_AVAILABLE_JOBS',
	CLEAR_JOBS: 'CLEAR_JOBS',
	SWITCH_JOBS_CONTEXT: 'SWITCH_JOBS_CONTEXT',
	TOGGLE_FILTER: 'TOGGLE_FILTER',
	CLEAR_ALL_FILTERS: 'CLEAR_ALL_FILTERS',
	UPDATE_JOB_DETAILS: 'UPDATE_JOB_DETAILS',
	CLEAR_CURRENT_JOB: 'CLEAR_CURRENT_JOB'
}

export const mutations: MutationTree<any> = {
	[JobsMutations.UPDATE_AVAILABLE_JOBS] (state: JobsState, payload: AvailableJobsResponseData) {
		state.jobs = payload.jobs
		state.total_jobs = payload.total
	},
	[JobsMutations.CLEAR_JOBS] (state: JobsState) {
		state.jobs = []
	},
	[JobsMutations.SWITCH_JOBS_CONTEXT] (state: JobsState, payload: JobsContextItem) {
		state.context = payload;
	},
	[JobsMutations.TOGGLE_FILTER] (state: JobsState, payload: JobsFilters | number) {
		if (payload === 0) {
			state.filters.clear()
		} else {
			if (state.filters.has(payload)) {
				state.filters.delete(payload);
			} else {
				state.filters.add(payload);
			}
		}
	},
	[JobsMutations.CLEAR_ALL_FILTERS] (state: JobsState) {
		state.filters.clear();
	},
	[JobsMutations.UPDATE_JOB_DETAILS] (state: JobsState, payload: CurrentJob) {
		state.current_job = payload;
	},
	[JobsMutations.CLEAR_CURRENT_JOB] (state: JobsState) {
		state.current_job = null;
	}
}
